export default function WinterGlow() {
  return <div className="atmos-animation atmos-winter-glow" aria-hidden="true" />;
}
